import React from 'react';
import styled from 'styled-components';
import Tippy from '@tippyjs/react';
import { Icons } from 'autenti-components';
const RadioStyles = styled.label `
  display: flex;
  align-items: baseline;
  position: relative;
  padding: 7px 10px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: ${(props) => props.checked ? props.backgroundColor : 'none'};
  &:hover {
    background-color: ${(props) => props.backgroundColor || 'none'};
  }
  &.disabled-class:hover {
    cursor: ${(props) => !props.disableCursorNotAllowed && 'not-allowed'};
  }
  &.disabled-class,
  &.disabled-class .checkmark {
    border-color: #979797;
    color: #979797;
  }
  input {
    appearance: none;
    display: none;
  }
  input:checked ~ .checkmark:after {
    display: block;
  }
  .checkmark {
    position: relative;
    left: 0;
    height: 14px;
    width: 14px;
    border-radius: 50%;
    border: 1px solid #000;
    min-width: 14px;
  }
  /* Inner circle */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #000;
  }
  .icon {
    margin: 0 0 0 8px;
  }
  .text {
    align-self: center;
    margin-left: 8px;
  }
`;
export const TooltipStyles = styled.div `
  position: relative;
  top: 7px;
  margin-right: 8px;
`;
export const TooltipText = styled.span `
  font-size: ${(props) => props.theme.fontXXSmall};
  line-height: 18px;
`;
const Black = ({ id, inputProps, Icon, text, className, backgroundColor, tooltipText, }) => (React.createElement(React.Fragment, null,
    React.createElement(RadioStyles, { id: id, backgroundColor: backgroundColor || 'gray', checked: inputProps.checked, className: className, htmlFor: inputProps.id, disableCursorNotAllowed: inputProps.disableCursorNotAllowed },
        React.createElement("input", Object.assign({ type: "radio" }, inputProps)),
        React.createElement("span", { className: "checkmark" }),
        Icon && React.createElement("span", { className: "icon" }, Icon),
        React.createElement("span", { className: "text" }, text)),
    tooltipText && (React.createElement(TooltipStyles, null,
        React.createElement(Tippy, { content: React.createElement(TooltipText, null, tooltipText), arrow: true },
            React.createElement("div", null,
                React.createElement(Icons.AddInfo, { width: 12, height: 12 })))))));
export default Black;
